import React from 'react';
import Header from '../../../shared/layout/Header';
import { PROPERTY_WIZARD_STEPS } from '../propertyWizardConfig';

function StepRail({ activeStep }) {
  const progress = ((activeStep + 1) / PROPERTY_WIZARD_STEPS.length) * 100;

  return (
    <aside className="pw-step-rail" aria-label="مراحل ثبت ملک">
      <div className="pw-rail-heading">
        <span className="pw-rail-kicker">ثبت هوشمند ملک</span>
        <strong>{activeStep + 1} از {PROPERTY_WIZARD_STEPS.length} مرحله</strong>
      </div>
      <ol className="pw-step-list">
        {PROPERTY_WIZARD_STEPS.map((label, index) => (
          <li
            key={label}
            className={`${index === activeStep ? 'active' : ''} ${index < activeStep ? 'complete' : ''}`}
            aria-current={index === activeStep ? 'step' : undefined}
          >
            <span className="pw-step-dot">{index + 1}</span>
            <span className="pw-step-name">{label}</span>
          </li>
        ))}
      </ol>
      <div className="pw-rail-footer">
        <span>پیشرفت ثبت</span>
        <strong>{Math.round(progress)}٪</strong>
        <div className="pw-rail-progress"><span style={{ width: `${progress}%` }} /></div>
      </div>
    </aside>
  );
}

function WizardLayout({
  activeStep,
  dashboard,
  error,
  loading,
  onShowDashboard,
  onSkipStep,
  canSkipStep,
  children,
}) {
  return (
    <div className="property-wizard">
      <Header />
      <main className={`pw-shell ${dashboard ? 'pw-shell--dashboard' : ''}`}>
        {!dashboard ? (
          <section className="pw-workspace">
            <StepRail activeStep={activeStep} />
            <div className="pw-stage">
              <header className="pw-stage-header">
                <div className="pw-stage-title">
                  <span className="pw-current-step">{activeStep + 1}</span>
                  <div>
                    <small>مرحله فعلی</small>
                    <h1>{PROPERTY_WIZARD_STEPS[activeStep]}</h1>
                  </div>
                </div>
                <button className="pw-dashboard-link" type="button" onClick={onShowDashboard}>
                  مدیریت املاک و آگهی‌ها
                </button>
              </header>
              {canSkipStep && (
                <div className="pw-skip-row">
                  <span>می‌توانید این اطلاعات را بعداً با کمک مشاور تکمیل کنید.</span>
                  <button className="pw-skip-button" type="button" onClick={onSkipStep} disabled={loading}>
                    فعلاً رد شو
                  </button>
                </div>
              )}
              {error && <div className="pw-error" role="alert">{error}</div>}
              <div className={`pw-step-canvas pw-step-canvas--${activeStep}`}>{children}</div>
            </div>
          </section>
        ) : (
          <div className="pw-dashboard-canvas">
            {error && <div className="pw-error" role="alert">{error}</div>}
            {children}
          </div>
        )}
      </main>
      {loading && (
        <div className="loading-overlay" role="status" aria-live="polite">
          <div className="loading-spinner">⏳</div>
          <div className="loading-text">در حال بارگذاری...</div>
        </div>
      )}
    </div>
  );
}

export default WizardLayout;
